
import { toast } from "sonner";
import { v4 as uuidv4 } from "uuid";
import { Folder } from "./types";
import { getFolders, saveFolders, getSavedJourneys, saveJourneys } from "./storageUtils";

export const createFolder = (name: string): Folder => {
  try {
    const folders = getFolders();
    
    const newFolder: Folder = {
      id: uuidv4(),
      name: name.trim() || "Untitled Folder",
      timestamp: new Date().toISOString()
    };
    
    folders.push(newFolder);
    saveFolders(folders);
    
    toast.success(`Created folder "${newFolder.name}"`);
    return newFolder;
  } catch (error) {
    console.error("Error creating folder:", error);
    toast.error("Failed to create folder");
    throw error;
  }
};

export const updateFolder = (id: string, name: string): boolean => {
  try {
    const folders = getFolders();
    const folderIndex = folders.findIndex(folder => folder.id === id);
    
    if (folderIndex === -1) {
      toast.error("Folder not found");
      return false;
    }
    
    folders[folderIndex].name = name.trim() || "Untitled Folder";
    saveFolders(folders);
    
    toast.success(`Renamed folder to "${folders[folderIndex].name}"`);
    return true;
  } catch (error) {
    console.error("Error updating folder:", error);
    toast.error("Failed to update folder");
    return false;
  }
};

export const deleteFolder = (id: string): boolean => {
  try {
    const folders = getFolders();
    const filteredFolders = folders.filter(folder => folder.id !== id);
    
    if (filteredFolders.length === folders.length) {
      toast.error("Folder not found");
      return false;
    }
    
    saveFolders(filteredFolders);
    
    // Update journeys to remove folder association
    const journeys = getSavedJourneys();
    const updatedJourneys = journeys.map(journey => {
      if (journey.folderId === id) {
        return { ...journey, folderId: null };
      }
      return journey;
    });
    
    saveJourneys(updatedJourneys);
    
    toast.success("Folder deleted");
    return true;
  } catch (error) {
    console.error("Error deleting folder:", error);
    toast.error("Failed to delete folder");
    return false;
  }
};
